import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ResourceAutoCompleteViewModelType } from '../../../../../extViewmodels';
import { RadioButton } from '../../../../../web/components/RadioButton';
import {
	ISimpleAutoCompleteSearchFieldItemSelectionEvent,
	SimpleAutoCompleteSearchField,
} from '../../../../../web/components/autocomplete/SimpleAutoCompleteSearchField';
import { XIcon } from '../../../../../web/components/svgs/icons/XIcon';
import { charmGray } from '../../../../../web/styles/colors';
import { baseStyleSheet } from '../../../../../web/styles/styles';
import { LeadRuleViewModel, TurnItOnForOptions } from '../../../../viewModels/leadrules';
import { styleSheet } from '../../styles';

interface IProps {
	enabled: boolean;
	leadRule: LeadRuleViewModel;
	onChangeToEnable: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DailyActivityTeam: React.FC<IProps> = observer(({ enabled, leadRule, onChangeToEnable }) => {
	const onSelected = (event: ISimpleAutoCompleteSearchFieldItemSelectionEvent<string>) => {
		leadRule?.setDailyActivityTeams(leadRule?.dailyActivityTeams?.concat(event.selection));
	};
	const onRemoved = (option: string) => () => {
		leadRule?.setDailyActivityTeams(leadRule?.dailyActivityTeams.filter((item: string) => item !== option));
	};
	return (
		<div>
			<RadioButton checked={enabled} id={TurnItOnForOptions.DailyActivityTeam} onChange={onChangeToEnable}>
				<span className={css(styleSheet.radioLabel)}>Daily Team(s)</span>
			</RadioButton>
			<div
				className={css(
					styleSheet.radioContent,
					!enabled && baseStyleSheet.disabled,
					!enabled && baseStyleSheet.disableInteraction
				)}
			>
				{enabled && (
					<>
						<div className={css(styleSheet.userSearchField)}>
							<SimpleAutoCompleteSearchField
								initialSearchQuery=''
								// @ts-ignore
								onItemSelected={onSelected}
								pageSize={5}
								placeholder='Search Daily Team'
								resultsLimit={5}
								type={ResourceAutoCompleteViewModelType.DailyActivityTeam}
							/>
						</div>
						{leadRule?.dailyActivityTeams?.map((item: string) => {
							return (
								<div key={item} className={css(styleSheet.selectedUser)}>
									<button onClick={onRemoved(item)}>
										<span>
											<XIcon color={charmGray} height={12} width={12} />
										</span>
									</button>
									<span className={css(styleSheet.userName)}>{item}</span>
								</div>
							);
						})}
					</>
				)}
			</div>
		</div>
	);
});
